import { render } from "./AppointmentInformation.vue?vue&type=template&id=b9b65b2c"
import script from "./AppointmentInformation.vue?vue&type=script&lang=js"
export * from "./AppointmentInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__